"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KiloVolt = exports.MilliVolt = exports.Volt = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var power_1 = require("./power");
/**
 * The derived unit for electric potential difference, electromotive force ( <code>V</code> ).
 * One Volt is equal to the difference of electric potential between two points on a conducting
 * wire carrying a export constant current of one ampere when the power dissipated between the points is one watt.
 * It is named after the Italian physicist Count Alessandro Volta (1745-1827).
 */
exports.Volt = UnitDivide.powerByElectricalCurrent("Volt", power_1.Watt, uom_1.BaseUnits.Ampere);
// ElectricPotential
exports.MilliVolt = uom_1.UnitPrefix.Milli("MilliVolt", exports.Volt);
exports.KiloVolt = uom_1.UnitPrefix.Kilo("KiloVolt", exports.Volt);
//# sourceMappingURL=electric-potential.js.map